import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import AssignedDossierTask from '../models/AssignedDossierTask';
import { parseAppointment } from './appointmentConverters';
import { ABSTRACT_SCHEMA } from './taskConverters';

const SCHEMA = {
  ...ABSTRACT_SCHEMA,
  isWaitingForCheckIn: 'isWaitingForCheckIn',
  tags: (data: any) => parseTags(data.tags),
  appointment: parseAppointment,
};

export function parseAssignedDossierTasks(data: any): Array<AssignedDossierTask> {
  return parseEntities(data, parseAssignedDossierTask);
}

export function parseAssignedDossierTask(data: any): AssignedDossierTask | null {
  return parseEntity({ dossierId: data.id, ...data }, SCHEMA, AssignedDossierTask);
}
